import { useCallback, useEffect, useLayoutEffect, useRef } from 'react';

const useIsomorphicLayoutEffect = typeof window === 'undefined' ? useEffect : useLayoutEffect;

type UseLoadMoreScrollRestorationOptions = {
  itemCount: number;
  loading: boolean;
  loadMore: () => void;
};

export const useLoadMoreScrollRestoration = ({
  itemCount,
  loading,
  loadMore,
}: UseLoadMoreScrollRestorationOptions) => {
  const pendingScrollYRef = useRef<number | null>(null);
  const previousItemCountRef = useRef(itemCount);

  useIsomorphicLayoutEffect(() => {
    const previousItemCount = previousItemCountRef.current;
    previousItemCountRef.current = itemCount;

    if (pendingScrollYRef.current === null) {
      return;
    }

    if (itemCount > previousItemCount) {
      window.scrollTo({ top: pendingScrollYRef.current });
      pendingScrollYRef.current = null;
      return;
    }

    if (!loading) {
      pendingScrollYRef.current = null;
    }
  }, [itemCount, loading]);

  return useCallback(() => {
    pendingScrollYRef.current = window.scrollY;
    loadMore();
  }, [loadMore]);
};
